module.exports = __webpack_public_path__ + "img/vector-left.f1d742d7.svg";